<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="5" md="6" lg="7" align="right" style="">
        <iframe width="100%" height="450" frameborder="0" style="border:0"
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJm-MKd0jgKIYRCbJbVLPIE_g&key=AIzaSyAF2jp74YPZEgeecMam1UNH0U6jmH9Zboo" allowfullscreen></iframe>
      </v-col>



      <v-col cols="12" sm="5" md="4" lg="3" class="location">
        <div class="heading-location">
          Address
        </div>


        <div class="text-location">
          3000 Halls Ferry Rd <br>
          Lower Level <br>
          Vicksburg MS, 39180
        </div>

        <div class="heading-location mt-3">
          Telephone
        </div>

        <div class="text-location">
          <span style="font-weight: bold">Office:
            <a href="tel:6016389800" @click="track('LocationPhone', 'ClickToCall')">601-638-9800</a>
          </span> <br>
          Fax: 601-638-9808
        </div>


        <div class="heading-location mt-3">
          Office Hours
        </div>

        <div class="text-location">

          <!--<span style="color:red">Due to Covid, we are </span>-->
          <table>
            <tr>
              <td class="pr-0">Monday</td>
              <td>: 8:00am - 5:30pm</td>
            </tr>
            <tr>
              <td class="pr-0">Tuesday</td>
              <td>: 8:00am - 5:30pm</td>
            </tr>
            <tr>
              <td class="pr-0">Wednesday</td>
              <td>: 8:00am - 5:30pm</td>
            </tr>
            <tr>
              <td class="pr-0">Thursday</td>
              <td>: 8:00am - 5:30pm</td>
            </tr>
            <tr>
              <td>Friday</td>
              <td>: 8:00am - 3:00pm</td>
            </tr>
            <tr>
              <td>Sat - Sun</td>
              <td>: Closed</td>
            </tr>
          </table>
        </div>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
   import Section from '@/components/Section.vue'
   export default {
      name: "location",
      components: {Section, },
      methods:{
         track (eventLabel, category='SiteNavigation') {
            this.$gtag.event('ButtonClick', {
               'event_category': category,
               'event_label': eventLabel,
            })
         }
      },
   }
</script>

<style scoped lang="scss">

  .location{

    .heading-location{
      font-size: 1.2em;
      font-weight: bold;
      color: gray;

    }
    .text-location{
      font-size: 1em;
      padding-left: 10px;
    }

    a{
      text-decoration: none;
      color: black;
    }

  }




</style>